export const SHOW_REVIEWS_LIST_MINIMUM_REVIEWS = 1;
